import { EActionTypes } from '../../constants/actionTypes/formData';
import { IApplicationState, TReduxActions } from '../../types/redux';

const initialState: IApplicationState['formData'] = null;

export function formDataReducer(state = initialState, action: TReduxActions) {
  switch (action.type) {
    case EActionTypes.SET_FORM_DATA:
      return action.payload;

    case EActionTypes.SET_FORM_DATA_ERROR:
      return action.payload;

    default:
      return state;
  }
}
